/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import OpenInNew from '@mui/icons-material/OpenInNew';
import PdpQuantityCounter from './pdpQuantityCounter';
const PdpShopOnline = ({ variants, djangoPk, affiliatedLinks, onAddToShopifyCart, }) => {
    const VariantCard = ({ variant }) => {
        const { price, nursery, } = variant;
        const { shipping_info: shippingInfo, name } = nursery || {};
        const quantity = 'inventory_quantity' in variant
            ? variant.inventory_quantity
            : variant.quantity;
        const title = 'inventory_quantity' in variant
            ? variant.title
            : variant.size;
        const updatedName = name ? `${name}:` : '';
        const quantityText = quantity === 0
            ? (name || '')
            : quantity < 30
                ? `${updatedName} Fewer than ${quantity}`
                : `${updatedName} ${quantity} available`;
        return (React.createElement("div", { className: "modal_variant_container" },
            React.createElement("div", { className: "modal_shopify_variant_card_wrapper" },
                React.createElement("div", { className: "modal_shopify_variant_card" },
                    React.createElement("p", { className: "quantity_text" }, quantityText),
                    (title || price) && (React.createElement("p", { className: "title_price" },
                        React.createElement("span", null, title),
                        ' ',
                        "|",
                        ' ',
                        React.createElement("strong", null, "$"),
                        React.createElement("strong", null, price))),
                    React.createElement("p", { className: "shipping_info" }, shippingInfo),
                    !('handle' in variant) ? (React.createElement("a", { target: "_blank", rel: "noopener nofollow sponsored", href: variant.sale_url },
                        React.createElement("button", { style: {
                                width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 16,
                            }, type: "button", className: "btn primary ", onClick: () => gtag('event', 'buy_from_nursery') },
                            "Buy Direct from Nursery",
                            ' ',
                            React.createElement(OpenInNew, { sx: { padding: 0, marginLeft: 2 } })))) : (React.createElement(PdpQuantityCounter, { selectedVariant: variant, djangoPk: djangoPk, onAddToShopifyCart: onAddToShopifyCart, width: { counter: '42%', btn: '42%' } }))))));
    };
    return (React.createElement("div", { className: "pdp_shop_online" },
        React.createElement("h2", null, "Shop online"),
        React.createElement("div", { className: "modal_variants_wrapper" },
            (variants === null || variants === void 0 ? void 0 : variants.length) > 0 && (variants === null || variants === void 0 ? void 0 : variants.map((variant) => (React.createElement(VariantCard, { key: variant.id, variant: variant })))),
            (affiliatedLinks === null || affiliatedLinks === void 0 ? void 0 : affiliatedLinks.length) > 0 && (affiliatedLinks === null || affiliatedLinks === void 0 ? void 0 : affiliatedLinks.map((link) => (React.createElement(VariantCard, { key: link.id, variant: link })))))));
};
export default PdpShopOnline;
